import type { PaymentFormData } from '#/features/payment-edit'
import type {
  ShipmentConvert,
  ShipmentUpdate,
} from '#/shared/api/generated/shipment/models'
import { moneyFormStringToApi } from './money'
import {
  toShipmentCodMethod,
  toShipmentPaymentMethod,
  toShipmentPaymentTerm,
  toShipmentPaymentTerms,
  toShipmentTermBegins,
} from './payment-enum-map'

function nullify(value: string): string | null {
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function buildPaymentUpdate(payment: PaymentFormData): ShipmentUpdate {
  return {
    tariff: moneyFormStringToApi(payment.totalTariff),
    deposit: moneyFormStringToApi(payment.deposit),
    carrier_pay: moneyFormStringToApi(payment.carrierFee),
    payment_method: toShipmentPaymentMethod(payment.paymentMethod),
    payment_terms: toShipmentPaymentTerms(payment.paymentTerms),
    dispatch_cod_method: toShipmentCodMethod(payment.balanceMethod),
    dispatch_payment_term: toShipmentPaymentTerm(payment.balanceTime),
    dispatch_term_begins: toShipmentTermBegins(payment.balanceTermBegins),
    payment_notes: nullify(payment.paymentNote),
  }
}

export function buildPaymentConvert(
  payment: PaymentFormData,
  stage: string,
): ShipmentConvert {
  return {
    stage,
    status: stage,
    tariff: moneyFormStringToApi(payment.totalTariff),
    deposit: moneyFormStringToApi(payment.deposit),
    carrier_pay: moneyFormStringToApi(payment.carrierFee),
  }
}
